(function(){
    'use strict';
    angular.module('app').controller('VehicleTypeDetailsController', VehicleTypeDetailsController);

    VehicleTypeDetailsController.$inject = [
        '$scope',
        'FleetService',
        '$routeParams',
        '$location',
        '$timeout',
        'toastr',
        'FleetVehiclesTableService',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        '$rootScope',
        'Units',
        'hasDuplicate',
        'icons'
    ];

    function VehicleTypeDetailsController(
        $scope,
        FleetService,
        $routeParams,
        $location,
        $timeout,
        toastr,
        FleetVehiclesTableService,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        $rootScope,
        Units,
        hasDuplicate,
        icons
    ) {
        const vm = this;
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_VEHICLE_TYPE_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_VEHICLE_TYPE_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next) {
            if(!vm.isViewMode && isChanged(vm.vehicleType, vm.vehicleTypeRaw)){
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if( _.contains(next.$$route.originalPath, ':') ){
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });
        const deleteConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        vm.vehicleTypeId = $routeParams.id;
        vm.currentUser = $rootScope.GlobalProfile;
        vm.weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
        const measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
        vm.measureUnit = measureUnit ? measureUnit === 'CM' ? 'M' : 'F' : 'M';
        vm.icons = icons.map;
        vm.vehicleType = {
            vehicleIcon: {
                key: 'car',
                value: vm.icons['car']
            }
        };
        vm.vehicleTypeRaw = angular.copy(vm.vehicleType);
        vm.isViewMode = false;
        vm.fleetVehiclesTableData = null;
        vm.saveInProgress = false;

        vm.isUnique = isUnique;
        vm.saveDetails = saveDetails;
        vm.changeStatus = changeStatus;
        vm.getPreviousRoute = getPreviousRoute;
        vm.deleteVehicleType = deleteVehicleType;
        (()=>{
            if($routeParams.id) {
                vm.isFetching = true;
                FleetService.VehicleTypes.get(vm.vehicleTypeId, function(result) {
                    vm.isFetching = false;
                    getFleetVehicles(result.id);
                    initVehicleType(result);
                }, function() {
                });
            }
        })();
        function initVehicleType(data) {
            const result = angular.extend({}, data, {
                wheelBase:data.wheelBase / 100,
                vehicleIcon: data.icon ? {
                    key: data.icon,
                    value: vm.icons[data.icon]
                } : {
                    key: 'car',
                    value: vm.icons['car']
                }
            });
            vm.vehicleType = angular.copy(result);
            vm.vehicleTypeRaw = angular.copy(result);
        }
        function getFleetVehicles(typeId) {
            vm.fleetVehiclesTableData = new FleetVehiclesTableService({exclude: ['type'], filter: {
                vehicleTypeId: typeId
            }}).tableData;
        }

        function changeStatus(evt) {
            evt.preventDefault();
            if(vm.vehicleType.active){
                vm.vehicleType.active = false;
                toActiveConf.getInstance().result.then(function (cond) {
                    if(cond) vm.vehicleType.active = true;
                });
                return false;
            }
            vm.vehicleType.active = true;
            toInactiveConf.getInstance().result.then(function (cond) {
                if(cond) vm.vehicleType.active = false;
            });
        }

        function getPreviousRoute() {
            if($routeParams.vehicleId){
                return '/fleets/vehicles/details/' + $routeParams.vehicleId;
            }
            return '/fleets/vehicle-types/';
        }

        function cleanPayload(vehicleType) {
            const {name, code, description, maxWeight, wheelBase, active, vehicleIcon} = vehicleType;
            return {name,
                code,
                description,
                maxWeight,
                wheelBase: wheelBase * 100,
                active,
                weightUnit: $rootScope.GlobalProfile.office.weightUnit,
                measureUnit,
                icon: vehicleIcon.key
            };
        }

        function isChanged(o, n) {
            return !angular.equals(cleanPayload(o), cleanPayload(n));
        }

        function isUnique(model) {
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.VehicleTypes.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model,
                compareBy: 'code',
                raw: angular.getObjVal(vm, 'vehicleTypeRaw.code'),
                filters: {
                    size: 2,
                    page: 0,
                    sort: 'id,desc',
                    code: model
                }
            }).then(res => {
                vm.codeError = res ? 'Vehicle type code is already taken' : null;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }

        function saveDetails(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInProgress = true;
            if($routeParams.id){
                FleetService.VehicleTypes.update(vm.vehicleTypeId, cleanPayload(vm.vehicleType), result=>{
                    vm.saveInProgress = false;
                    toastr.success('Data successfully updated');
                    initVehicleType(result);
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }else{
                FleetService.VehicleTypes.create(cleanPayload(vm.vehicleType), result=>{
                    onRouteChange();
                    $location.path('/fleets/vehicle-types/details/' + result.id);
                    toastr.success('Data successfully created');
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }
        }
        function deleteVehicleType(vehicleType) {
            deleteConf.getInstance().result.then(cond=>{
                if(cond){
                    FleetService.VehicleTypes.delete(vehicleType.id, data=>{
                        toastr.success('Vehicle Type successfully deleted');
                        onRouteChange();
                        $location.path('/fleets/vehicle-types');
                    }, err=>{
                        toastr.error('Unable to do request. Please try again later', err.message);
                    })
                }
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/VehicleTypeDetailsController.js